export enum ImageHeight {
  nHD = '360',
  qHD = '540',
  HD = '720',
  FHD = '1080',
  QHD = '1440',
}
